
import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { DialogHeader } from "@/components/admin/strategy-form/dialog/DialogHeader";
import AccountForm from "./AccountForm";
import { Account, LeadAccount, StrategyWithDetails } from "@/types/strategy-types";
import { useModalStack } from "@/hooks/useModalStack";

interface AccountFormDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (account: Partial<Account>) => Promise<void>;
  initialData?: Account;
  leadAccounts: LeadAccount[];
  strategies: StrategyWithDetails[];
  userRole?: string | null;
}

const AccountFormDialog = ({
  isOpen,
  onClose,
  onSubmit,
  initialData,
  leadAccounts,
  strategies,
  userRole
}: AccountFormDialogProps) => {
  const isEditing = !!initialData;
  const title = isEditing ? "Edit Account" : "Create New Account";
  
  // Use our modal stack hook to manage nested dialogs
  const { handleOpenChange } = useModalStack(isOpen, onClose);
  
  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader title={title} onClose={onClose} />
        <AccountForm
          onSubmit={onSubmit}
          initialData={initialData}
          leadAccounts={leadAccounts}
          strategies={strategies}
          onCancel={onClose}
          userRole={userRole}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AccountFormDialog;
